import {POST, GET, DELETE} from "@/services/gateway";

const listCompare = ({pagination,}) => {
  return POST('recovery/compare/entra-id/list', {pagination})
}

const listComparison = ({pagination, id, searchTerm, includeUnchanged, status}) => {
  return POST(`recovery/compare/entra-id/comparison`, {pagination, id, searchTerm, includeUnchanged, status})
}

const deleteCompare = (id) => {
  return DELETE(`recovery/export`, id)
}

const downloadCompare = (id) => {
  return GET(`recovery/export/${id}/download`)
}

const cancelCompare = (id) => {
  return GET(`entra-id/compare/${id}/cancel`)
}

export {
  listCompare,
  downloadCompare,
  deleteCompare,
  cancelCompare,
  listComparison,
}
